import { createSelector } from "reselect";

export const selectVehicleChecklistReport = ({
    VehicleCheckListV2_reducer
}) => {
    return VehicleCheckListV2_reducer.report;
};
export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};
export const selectPermissions = createSelector(
    [selectConfig, selectProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level]["vehicle_checklist"];
        } else return false;
    }
);

export const canUpdate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.update : true;
    }
);
export const selectReport = createSelector(
    [selectVehicleChecklistReport],
    report => {
        if (report === false) {
            return false;
        }
        return report;
    }
);
